import type {
  LoginRequest,
  LoginResponse,
  PasswordResetConfirmRequest,
  PasswordResetRequest,
  SandboxUser,
  SignUpRequest,
} from "sandbox/types";

export const fromSignIn = (input: {
  email: string;
  password: string;
}): LoginRequest => ({
  user_name: input.email,
  password: input.password,
});

export const fromSignUp = (input: {
  fullName?: string;
  country: string;
  company: string;
  email: string;
  password: string;
  role?: string;
  agreedToTerms: boolean;
  marketingConsent?: boolean;
}): SignUpRequest => ({
  user_name: input.email.split("@")[0].replace(/[^a-zA-Z0-9_-]/g, "_"),
  full_name: input.fullName,
  country: input.country,
  password: input.password,
  email: input.email,
  company_name: input.company,
  title: input.role,
  terms_of_use: input.agreedToTerms,
  consent: input.marketingConsent,
});

export const fromSignUpPardot = (input: {
  firstName?: string;
  lastName?: string;
  country: string;
  company: string;
  email: string;
  password: string;
  role?: string;
  agreedToTerms: boolean;
  marketingConsent?: boolean;
}): SignUpRequest => ({
  user_name: input.email.split("@")[0].replace(/[^a-zA-Z0-9_-]/g, "_"),
  first_name: input.firstName,
  last_name: input.lastName,
  country: input.country,
  password: input.password,
  email: input.email,
  company_name: input.company,
  title: input.role,
  terms_of_use: input.agreedToTerms,
  consent: input.marketingConsent,
});

export const fromPasswordResetRequest = (
  email: string,
): PasswordResetRequest => ({
  identifier: email,
});

export const fromPasswordResetConfirm = (input: {
  token: string;
  newPassword: string;
}): PasswordResetConfirmRequest => ({
  token: input.token,
  new_password: input.newPassword,
});

export const fromUpdatePassword = (input: {
  currentPassword: string;
  newPassword: string;
}): { old_password: string; new_password: string } => ({
  old_password: input.currentPassword,
  new_password: input.newPassword,
});

export const toUser = (response: LoginResponse): SandboxUser => ({
  firstName: response.first_name,
  lastName: response.last_name,
  company: response.company_name,
  email: response.email,
  userId: response.user_id,
});

export const toAccessToken = (response: LoginResponse): string =>
  response.access_token;
